import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {HeaderTitleProps} from './HeaderTitleProps.interface';

export function HeaderTitle({children, className, ...props}: HeaderTitleProps) {
  return (
    <Text
      className={twMerge(
        'font-large3-bold inline-block py-14pxr text-theme-solid-100',
        className
      )}
      {...props}
    >
      {children}
    </Text>
  );
}
